<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="汽车维修培训" nav-active="1-4" :menuItems="menuItems"></lx-navigator>
    <el-main style="padding: 0 10px; height: 100%; ">
      <el-row class="lx-right-title">
        <el-col>汽车维修培训-变速器同步器</el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>考核记录</el-col>
        <el-col :span="4" style="text-align: right">
          <el-button type="primary" size="small" @click="addCheck">添加考核</el-button>
        </el-col>
      </el-row>
      <el-row style="height: calc(100% - 110px); background-color: #fff; padding: 10px; ">
        <el-row>
          <el-col :span="24">
            <lx-check-record v-for="(record, index) in pageData.rows" :key="'record' + index" :check-record="record" :check-setting="checkSetting" @delete-record="handleDeleteRecord"></lx-check-record>
          </el-col>
        </el-row>
        <el-row class="lx-pagination-row" v-if="pageData.total > 0">
          <el-col :span="24">
          <el-pagination :total="pageData.total" :page-size="pageData.size" :current-page.sync="pageData.page" background layout="total, prev, pager, next" @current-change="initData"></el-pagination>
        </el-col>
        </el-row>
        <el-row v-else>暂无考核记录</el-row>
      </el-row>
    </el-main>
    <lx-check-dialog :dialog-visible="checkDialogVisible" :check-name="checkName" @dialog-close="closeDialog" @check-add="sureAddCheck"></lx-check-dialog>
  </el-container>
</template>
<script>
import Navigator from '@/components/common/Navigator'
import CheckDialog from '@/components/check/CheckDialog'
import CheckRecords from '@/components/check/CheckRecords'

export default {
  components: { 'lx-navigator': Navigator, 'lx-check-record': CheckRecords, 'lx-check-dialog': CheckDialog },
  data () {
    return {
      menuItems: [
        { index: '1-1', name: '发动机拆装与检查', route: {name: 'CheckEngineManager'} },
        { index: '1-2', name: '气缸的测量', route: {name: 'CylinderlManager'} },
        { index: '1-3', name: '曲轴的测量', route: {name: 'CrankshaftManager'} },
        { index: '1-4', name: '变速器同步器', route: {name: 'TransmissionManager'} }
      ],
      nowIndex: 0,
      pageData: {},
      checkDialogVisible: false,
      checkName: { name: '变速器同步器', value: 4 },
      checkSetting: 'TransmissionCheckSetting'
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      let queryForm = { trainProjectId: 4, page: this.pageData.page, size: 6 }
      this.$xhrGet(`/checks`, queryForm).then(rs => {
        if (rs.code === 200) {
          this.pageData = rs.data
        }
      })
    },
    addCheck () {
      this.checkDialogVisible = true
      // this.$xhrGet(`/checks/targets`).then(rs => {
      //   if (rs.code === 200) {
      //     this.checkName = rs.data[0]
      //   }
      // })
    },
    sureAddCheck () {
      this.checkDialogVisible = false
      this.initData()
    },
    closeDialog () {
      this.checkDialogVisible = false
    },
    handleDeleteRecord () {
      this.initData()
    }
  }
}
</script>

<style scoped>
/deep/ .el-input__inner { border: 0; }
</style>



// WEBPACK FOOTER //
// src/components/check/TransmissionManager.vue